/**
 * The date both article pages print above the title. UTC, because the CMS
 * timestamp is UTC and rendering it in the reader's zone would show a different
 * day either side of midnight from the one the published page shows.
 */
export default function updatedOn(updatedAt: string | null): string | null {
  return updatedAt
    ? new Date(updatedAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC",
      })
    : null;
}
